import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IConfig } from '../interfaces/app-config.interface';
import { ApiHealthService } from './api-health.service';
import { AppConfig } from './app-config.service';
import { CookieService } from 'ngx-cookie';

const DISABLE_MAINTENANCE_COOKIE = 'disable-maintenance';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private maintenance?: boolean = undefined;
  private savedUrl?: string;

  constructor(
    private appConfig: AppConfig,
    private apiHealthService: ApiHealthService,
    private router: Router,
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
    if (this.appConfig.config.maintenance.liveCheckEnabled) {
      interval(1000)
        .pipe(tap(() => (this.maintenance = undefined)))
        .subscribe();

      interval(10000)
        .pipe(
          switchMap(() => this.isUnderMaintenance()),
          switchMap(async (maintenance: boolean) => {
            if (maintenance && !this.router.isActive('/maintenance', true)) {
              console.log('Redirecting to maintenance page...');
              this.saveUrl(this.router.routerState.snapshot.url);
              await this.router.navigate(['/maintenance']);
            } else if (!maintenance && this.router.isActive('/maintenance', true)) {
              window.location.replace(this.savedUrl || '/');
              window.location.reload();
            }
            this.maintenance = maintenance;
          }),
        )
        .subscribe();
    }
  }

  public async isUnderMaintenance(): Promise<boolean> {
    if (this.appConfig.config.maintenance.liveCheckEnabled || this.appConfig.config.maintenance.planned) {
      if (this.maintenance === undefined) {
        // this.maintenance = (this.notDisabledByCookie() && (await this.checkConfig())) || (await this.checkApiHealth());
        this.maintenance = await this.checkConfig() || await this.checkApiHealth();
      }
      return this.maintenance;
    } else {
      return false;
    }
  }

  public saveUrl(url: string): void {
    if (url === '/maintenance') {
      url = '/';
      console.log('Cannot save url: /maintenance. Falling back to /.');
    }
    console.log('Saving url', url);
    this.savedUrl = url;
  }

  private async checkConfig(): Promise<boolean> {
    var config = (await this.http.get<IConfig>(`${environment.configUrl}?t=${new Date().getTime()}`)
      .toPromise()).maintenance;

    if (config.active) {
      console.log('Maintenance step detected in config');
      return true;
    } else {
      if (config.plan && config.planned && config.plan.from && config.plan.to) {
        if (this.isNowDuringPolishMaintenance(config.plan.from, config.plan.to)) {
          return true;
        }
      }
    }

    return false;
  }


  private checkApiHealth(): boolean {
    if (!this.apiHealthService.isApiHealthy()) {
      console.log('Maintenance step detected in API.');
      return true;
    } else {
      return false;
    }
  }

  private notDisabledByCookie() {
    return this.cookieService.get(DISABLE_MAINTENANCE_COOKIE) !== 'true';
  }



  private parsePolishTimeToUtc(input: string): Date {
    const date = new Date(input); // czas jako string, np. "2025-03-26T13:35:00"

    // Tworzymy formatowaną datę w Europe/Warsaw
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Warsaw',
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const parts = formatter.formatToParts(date);
    const get = (type: string) => parts.find(p => p.type === type)!.value;

    const year = get('year');
    const month = get('month');
    const day = get('day');
    const hour = get('hour');
    const minute = get('minute');
    const second = get('second');

    // Składamy znowu datę jako string w czasie Europe/Warsaw
    const warsawString = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

    // Teraz traktujemy ten string jako lokalny, JS przeliczy go na UTC
    return new Date(warsawString);
  }

  private localToUtc(): Date {
    return new Date(new Date().toISOString());
  }


  private isNowDuringPolishMaintenance(from: string, to: string): boolean {
    const nowUtc = new Date(); // UTC teraz
    const fromUtc = this.parsePolishTimeToUtc(from);
    const toUtc = this.parsePolishTimeToUtc(to);
    return nowUtc >= fromUtc && nowUtc <= toUtc;
  }
}
